import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

declare global {
  interface Window {
    $crisp: any;
    CRISP_WEBSITE_ID: string;
  }
}

interface CrispChatProps {
  websiteId: string;
}

const CrispChat: React.FC<CrispChatProps> = ({ websiteId }) => {
  const { user } = useAuth();

  useEffect(() => {
    // 只在用户登录后加载 Crisp
    if (!user) {
      // 如果用户未登录，清理可能存在的 Crisp 实例
      const existingScript = document.querySelector('script[src="https://client.crisp.chat/l.js"]');
      if (existingScript) {
        existingScript.remove();
      }
      
      const crispElements = document.querySelectorAll('[id^="crisp-"], .crisp-client');
      crispElements.forEach(element => element.remove());
      
      if (window.$crisp) {
        window.$crisp.push(['do', 'chat:close']);
        delete window.$crisp;
      }
      if (window.CRISP_WEBSITE_ID) {
        window.CRISP_WEBSITE_ID = '';
      }
      return;
    }

    // 设置Crisp网站ID
    window.CRISP_WEBSITE_ID = websiteId;
    
    // 创建Crisp脚本
    const script = document.createElement('script');
    script.src = 'https://client.crisp.chat/l.js';
    script.async = true;
    
    // 添加脚本到页面
    document.head.appendChild(script);
    
    // 初始化Crisp配置
    script.onload = () => {
      if (window.$crisp) {
        // 设置聊天框位置为左下角
        window.$crisp.push(['set', 'position', 'left']);
        
        // 可以设置其他配置
        window.$crisp.push(['set', 'theme', 'blue']);
        
        // 设置语言为中文
        window.$crisp.push(['set', 'locale', 'zh']);
      }
    };
    
    return () => {
      // 移除脚本
      const existingScript = document.querySelector('script[src="https://client.crisp.chat/l.js"]');
      if (existingScript) {
        existingScript.remove();
      }
      
      // 清理Crisp相关的DOM元素
      const crispElements = document.querySelectorAll('[id^="crisp-"], .crisp-client');
      crispElements.forEach(element => element.remove());
      
      // 清理全局变量
      if (window.$crisp) {
        window.$crisp.push(['do', 'chat:close']);
        delete window.$crisp;
      }
      if (window.CRISP_WEBSITE_ID) {
        window.CRISP_WEBSITE_ID = '';
      }
    };
  }, [websiteId, user]);
  
  return null; // 这个组件不渲染任何可见内容
};

export default CrispChat;